export default __webpack_public_path__ + "static/media/finished-sync.0dbbbaa5.svg";